const base = {
    cellSize: '24px',
    gridOverlayZIndex: 2,
};

export default base;
